import { render, staticRenderFns } from "./DataElementInfo.vue?vue&type=template&id=155062cf&scoped=true&"
import script from "./DataElementInfo.vue?vue&type=script&lang=js&"
export * from "./DataElementInfo.vue?vue&type=script&lang=js&"
import style0 from "./DataElementInfo.vue?vue&type=style&index=0&id=155062cf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155062cf",
  null
  
)

export default component.exports